import axios from 'axios';

export const isEmailAddressRepeted = (err: unknown) =>
  axios.isAxiosError(err) &&
  err.response?.data.documentsEmail?.includes('has already been taken');
